import { useEffect } from "react";

// Sets the browser tab title while the calling page is mounted and restores
// the previous title (normally "Vagmee" from index.html) on unmount, so a
// per-job co-branded title never leaks onto other pages. A falsy title
// leaves the tab untouched.
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => { document.title = previous; };
  }, [title]);
}

// 1×1 transparent GIF — a blank tab icon.
const BLANK_ICON = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

// While `hide` is true, swaps the Vagmee tab icon (index.html's
// <link rel="icon">) for a blank one — used on co-branded job pages — and
// restores the original on unmount / when `hide` turns false.
export function useHideFavicon(hide) {
  useEffect(() => {
    if (!hide) return undefined;
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return undefined;
    const previous = link.getAttribute("href");
    link.setAttribute("href", BLANK_ICON);
    return () => { link.setAttribute("href", previous); };
  }, [hide]);
}
